import React, { useEffect, useState } from 'react';
import API from 'src/utils/apiCalling';

import {
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from '@coreui/react';

import { diffBetweenTimes, comapareTime, timeAdd } from 'src/utils/common';

import { CustButton } from 'src/reusable';
import moment from 'moment';
import { timeGap } from 'src/utils/common';
import swal from 'sweetalert';
import { toast, ToastContainer } from 'react-toastify';

const ApprovalConfirmModal = props => {
  const api = new API();
  const {
    title,
    isShow,
    closeConfirmModal,
    handleOnSubmit,
    data,
    currentSelectedAction,
    isLoading,
  } = props;

  let attendanceLogs =
    data?.attendance_logs && JSON.parse(data?.attendance_logs);
  attendanceLogs =
    attendanceLogs &&
    attendanceLogs.length > 0 &&
    attendanceLogs.filter(item => item.reason);

  const [comment, setComment] = useState('');
  const [approveForStatus, setApproveStatus] = useState();
  const [commentErrorMsg, setCommentErrorMsg] = useState('');
  const [viewLogs, setViewLogs] = useState(false);

  const diffActualTime = diffBetweenTimes(
    data?.actual_check_in_time === 'No Punches' ||
      data?.actual_check_in_time === 'Invalid date'
      ? '00'
      : data?.actual_check_in_time,
    data?.actual_check_out_time === 'No Punches' ||
      data?.actual_check_out_time === 'Invalid date'
      ? '00'
      : data?.actual_check_out_time,
  );
  const diffCorrectionTime = diffBetweenTimes(
    data?.corrected_check_in_time || 0,
    data?.corrected_check_out_time || 0,
  );
  const diffTotalTime = diffBetweenTimes(
    `${diffActualTime?.diffHours || 0}:${diffActualTime?.diffMinutes || 0}`,
    `${diffCorrectionTime?.diffHours || 0}:${diffCorrectionTime?.diffMinutes ||
      0}`,
  );

  const handleOnChange = e => {
    const { value } = e.target;
    if (value && commentErrorMsg) {
      setCommentErrorMsg('');
    }
    setComment(e.target.value);
  };

  const handleOnRightBtnClick = () => {
    if (data.type === 'attendance_correction') {
      if (currentSelectedAction === 'reject' && !comment) {
        setCommentErrorMsg('Reason field is required');
        return;
      } else {
        if (!approveForStatus && currentSelectedAction === 'approve') {
          toast.error('Please select Approve For ');
          return;
        } else {
        }
      }

      const params = {
        type: data.type,
        is_approved: currentSelectedAction,
        id: 1, //id is fixed not in use
        comment: currentSelectedAction === 'reject' ? comment : 'approved',
        // approve_for:
        //   currentSelectedAction === 'approve' ? approveForStatus : null,
        correction_data: JSON.stringify([
          {
            id: data.id,
            approve_for:
              currentSelectedAction === 'approve' ? approveForStatus : null,
            comment: '',
          },
        ]),
      };
      handleOnSubmit(params);
    }
  };

  const formatValue = val => {
    return `${val < 0 ? '-' : ''} ${
      Math.abs(val) < 10 ? `0${Math.abs(val)}` : Math.abs(val)
    }`;
  };

  const handleApproveStatus = value => {
    let compareTime = value === 'full_day' ? '08:00:00' : '04:00:00';
    let status =
      comapareTime(actualNetWorking, compareTime) === 'isBefore' ? true : false;
    if (status) {
      swal({
        html: true,
        title: 'Are you sure?',
        text: `You are going to approval for ${
          value === 'full_day'
            ? `Full Day`
            : value === 'first_half_present'
            ? 'First half present'
            : `Second half present`
        } but net working hours is less then ${compareTime}`,
        icon: 'warning',
        buttons: ['No, cancel it!', 'Submit'],
        dangerMode: true,
      }).then(async function(isConfirm) {
        if (isConfirm) {
          setApproveStatus(value);
        } else {
          setApproveStatus('');
        }
      });
    } else {
      setApproveStatus(value);
    }
  };
  const actualCheckIn =
    data?.actual_check_in_time &&
    data?.actual_check_in_time != 'null' &&
    data?.actual_check_in_time !== 'Invalid date' &&
    data?.actual_check_in_time !== 'No Punches'
      ? data.actual_check_in_time
      : '00:00:00';
  const correctedCheckIn =
    data?.corrected_check_in_time &&
    data?.corrected_check_in_time != 'null' &&
    data?.corrected_check_in_time != 'Invalid date' &&
    data?.corrected_check_in_time != 'No Punches'
      ? data?.corrected_check_in_time
      : actualCheckIn;
  const diffOfCheckIn = timeGap(actualCheckIn, correctedCheckIn);
  const actualCheckOut =
    data?.actual_check_out_time &&
    data?.actual_check_out_time != 'null' &&
    data?.actual_check_out_time !== 'Invalid date' &&
    data?.actual_check_out_time !== 'No Punches'
      ? data.actual_check_out_time
      : '00:00:00';
  const correctedCheckOut =
    data?.corrected_check_out_time &&
    data?.corrected_check_out_time != 'null' &&
    data?.corrected_check_out_time !== 'Invalid date' &&
    data?.corrected_check_out_time !== 'No Punches'
      ? data?.corrected_check_out_time
      : actualCheckOut;
  const diffOfCheckout = timeGap(actualCheckOut, correctedCheckOut);
  const actualBreak =
    data?.actual_times?.breakHours ||
    data?.actual_times?.breakMinutes ||
    data?.actual_times?.breakSeconds
      ? `${
          data?.actual_times?.breakHours <= 9
            ? `0${data?.actual_times?.breakHours}`
            : data?.actual_times?.breakHours
        }:${
          data?.actual_times?.breakMinutes <= 9
            ? `0${data?.actual_times?.breakMinutes}`
            : data?.actual_times?.breakMinutes
        }:${
          data?.actual_times?.breakSeconds <= 9
            ? `0${data?.actual_times?.breakSeconds}`
            : data?.actual_times?.breakSeconds
        }`
      : '00:00:00';
  const correctedBreak =
    data?.corrected_times?.breakHours ||
    data?.corrected_times?.breakMinutes ||
    data?.corrected_times?.breakSeconds
      ? `${
          data?.corrected_times?.breakHours <= 9
            ? `0${data?.corrected_times?.breakHours}`
            : data?.corrected_times?.breakHours
        }:${
          data?.corrected_times?.breakMinutes <= 9
            ? `0${data?.corrected_times?.breakMinutes}`
            : data?.corrected_times?.breakMinutes
        }:${
          data?.corrected_times?.breakSeconds <= 9
            ? `0${data?.corrected_times?.breakSeconds}`
            : data?.corrected_times?.breakSeconds
        }`
      : actualBreak;
  const diffOfBreak = timeGap(actualBreak, correctedBreak);
  const actualWorkingHrs = timeGap(actualCheckIn, actualCheckOut);
  const correctedWorkingHrs = timeGap(correctedCheckOut, correctedCheckIn);
  const differenceOfworkingHrs = timeGap(actualWorkingHrs, correctedWorkingHrs);
  const actualNetWorking = timeGap(actualWorkingHrs, actualBreak);
  const correctedNetworking = timeGap(correctedWorkingHrs, correctedBreak);
  const differenceOfNetWorking = timeGap(actualNetWorking, correctedNetworking);

  const closeModalfun = () => {
    closeConfirmModal();
    setApproveStatus('');
    setComment('');
  };

  return (
    <div>
      <CModal show={isShow} onClose={closeModalfun} size="lg" backdrop={false}>
        <CModalHeader closeButton>
          <CModalTitle>{title}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          {data && (
            <div>
              <table className="table">
                <thead>
                  <tr>
                    <td colSpan={2}>
                      <strong style={{color:"darkblue"}}>Attendance Date :&nbsp;</strong>
                      <b style={{color:"brown"}}>{moment(data?.date).format('DD-MM-YYYY') || 'No Date'}</b>
                    </td>
                    <td colSpan={3}>
                      <strong style={{color:"darkblue"}}>Department :&nbsp;</strong>
                      <b style={{color:"brown"}}>{data?.department}</b>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={2}>
                      <strong style={{color:"darkblue"}}>Designation :&nbsp;</strong>
                      <b style={{color:"brown"}}>{data?.designation}</b>
                    </td>
                    <td colSpan={3}>
                      <strong style={{color:"darkblue"}}>Reporting Manager :&nbsp;</strong>
                      <b style={{color:"brown"}}>{data?.reporting_manager}</b>
                    </td>
                  </tr>
                  <tr>
                    <th width="20%"></th>
                    <th width="20%">Actual Time</th>
                    <th width="25%">Correction Time</th>
                    <th width="25%">Difference</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>Check In</th>
                    <td>{actualCheckIn}</td>
                    <td>{correctedCheckIn}</td>
                    <td>{diffOfCheckIn}</td>
                  </tr>
                  <tr>
                    <th>Check Out</th>
                    <td>{actualCheckOut}</td>
                    <td>{correctedCheckOut}</td>
                    <td>{diffOfCheckout}</td>
                  </tr>
                  {/* <tr>
                    <th>Break</th>
                    <td>{actualBreak}</td>
                    <td>{correctedBreak}</td>
                    <td>{diffOfBreak}</td>
                  </tr> */}

                  <tr>
                    <th>Working Hours</th>
                    <td className="">
                      <strong>
                        {actualWorkingHrs}
                        {/* {`${formatValue(
                          diffActualTime.diffHours,
                        )}:${formatValue(diffActualTime.diffMinutes)}`} */}
                      </strong>
                    </td>
                    <td className="">
                      <strong>
                        {correctedWorkingHrs}
                        {/* {`${formatValue(
                          diffCorrectionTime.diffHours,
                        )}:${formatValue(diffCorrectionTime.diffMinutes)}`} */}
                      </strong>
                    </td>
                    <td>{differenceOfworkingHrs}</td>
                  </tr>

                  <tr>
                    <th>Net Working</th>
                    <td
                      style={{
                        color: actualNetWorking[1] < 8 ? 'red' : 'green',
                      }}
                    >
                      {actualNetWorking}
                    </td>
                    <td
                      style={{
                        color: correctedNetworking[1] < 8 ? 'red' : 'green',
                      }}
                    >
                      {correctedNetworking}
                    </td>
                    <td
                      style={{
                        color: differenceOfNetWorking[1] < 1 ? 'green' : 'red',
                      }}
                    >
                      {differenceOfNetWorking}
                    </td>
                  </tr>
                  <tr>
                    <th>Total Correction Hours</th>
                    <td></td>
                    <td></td>
                    <td>
                      <span style={{ fontWeight: 'bold', color: 'blue' }}>
                        {timeAdd(
                          timeAdd(diffOfCheckIn, diffOfCheckout),
                          diffOfBreak,
                        )}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    {data?.requested_check_in_reason && (<>
                      <th style={{color:"darkblue"}} colSpan={1}>Check IN Reason : </th>
                      <td colSpan={3}>{data?.requested_check_in_reason}</td>
                      </>)}
                  </tr>
                  <tr>
                  {data?.requested_check_out_reason && (<>
                       <th style={{color:"darkblue"}} colSpan={1}>Check OUT Reason : </th>
                       <td colSpan={3}>{data?.requested_check_out_reason}</td>
                       </>)}
                  </tr>
                  {currentSelectedAction === 'approve' && (
                    <tr>
                      <th style={{color:"darkblue"}} colSpan={1}>Approve For</th>
                      <td>
                        <select
                          className="form-control"
                          onChange={e => handleApproveStatus(e.target.value)}
                          value={approveForStatus}
                        >
                          <option hidden>Select</option>
                          <option value="full_day">Full Day</option>
                          <option value="first_half_present">
                            First Half Day
                          </option>
                          <option value="second_half_present">
                            Second Half Day
                          </option>
                        </select>
                      </td>
                      <td>
                        {attendanceLogs?.length > 0 && (
                          <button
                            className="btn btn-primary"
                            onClick={() => setViewLogs(!viewLogs)}
                          >
                            {`${viewLogs ? 'Hide' : 'View'} Logs`}
                          </button>
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
          {viewLogs && (
            <table className="table table-striped">
              <thead>
                <tr>
                  <th scope="col">Emp ID</th>
                  <th scope="col">Person Name</th>
                  <th scope="col">Date</th>
                  <th scope="col">Time</th>
                  <th scope="col">Requested Time</th>
                  <th scope="col">Attendance Status</th>

                  <th scope="col">Reason</th>
                </tr>
              </thead>
              <tbody>
                {attendanceLogs &&
                  attendanceLogs.length > 0 &&
                  attendanceLogs.map((logs, index) => (
                    <tr>
                      <th scope="row">{logs?.emp_id}</th>
                      <td>{logs?.person_name}</td>
                      <td>{moment(logs?.auth_date).format('DD-MM-YYYY')}</td>
                      <td>{logs?.auth_time}</td>
                      <td>{logs?.requestedTime}</td>
                      <td>{logs?.attendenceStatus}</td>
                      <td><b style={{color:"red"}}>{logs?.reason}</b></td>
                    </tr>
                  ))}
              </tbody>
            </table>
          )}

          {/* {currentSelectedAction === 'reject' && ( */}
          <form>
            <div className="form-group">
              <label htmlFor="formGroupExampleInput">
                Reason <span className="required-field">*</span>
              </label>
              <textarea
                className="form-control"
                name="comment"
                value={comment}
                onChange={handleOnChange}
                id="comment"
                rows="3"
              ></textarea>
              <span className="error-msg">{commentErrorMsg}</span>
            </div>
          </form>

          {/* )} */}
        </CModalBody>
        <CModalFooter>
          <CustButton
            name="save-ar"
            text="Submit"
            color="primary"
            onClick={handleOnRightBtnClick}
            className="btn-loading btn-ladda"
            isDisabled={comment ? false : true}
            isLoading={isLoading}
          />
        </CModalFooter>
      </CModal>
      <ToastContainer/>
    </div>
  );
};

export default ApprovalConfirmModal;
